import React from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS } from '../../../../../constants/colors'
import { SimpleTooltip } from '../SimpleTooltip/SimpleTooltip'

export interface TeamValidationTooltipProps {
  message: string
  className?: string
}

export const TeamValidationTooltip: React.FC<TeamValidationTooltipProps> = ({ message, className = '' }) => {
  return (
    <SimpleTooltip content={message} placement="top" className={className}>
      <InformationCircleIcon className="w-5 h-5 cursor-help" style={{ color: INTERAX_COLORS.redError }} />
    </SimpleTooltip>
  )
}
